<template lang="pug">
  .component-quick-search(@focusout="handleFocusout")
    a(@click="searchOpen = !searchOpen").fa-stack.fa-lg
      i.fa.fa-circle.fa-stack-2x
      i.fa.fa-search.fa-stack-1x.fa-inverse
    template(v-if="searchOpen")
      .search-container
        .search.mt-2.card
          SearchEntity(entity="clients",  @selected="gotoEntity($event, 'clients')").mb-1
            template(v-slot:default="result")
              .quick-search-result
                div
                  small CL{{ result.result.id }}
                  div {{ result.result.name }} {{ result.result.surname }}
                  div(v-if="result.result.organization_name" )
                    small {{result.result.organization_name}}
                  div
                    small {{result.result.phone}}
          SearchEntity(entity="drivers",  @selected="gotoEntity($event, 'drivers')").mb-1
            template(v-slot:default="result")
              .quick-search-result
                div
                  small DR{{ result.result.id }}
                  div {{ result.result.name }} {{ result.result.surname }}
                  small {{result.result.mobile}}
          SearchEntity(entity="reservations", @selected="gotoEntity($event, 'reservations')").mb-1
            template(v-slot:default="result")
              .quick-search-result
                span R{{result.result.id}}
                span {{result.result.status}}
                small {{$dateFormat(result.result.start, $toMomentFormat(configuration.locale.locale_datetime_format.value))}} - {{$dateFormat(result.result.end, $toMomentFormat(configuration.locale.locale_datetime_format.value))}}
                small {{result.result.vehicle.brand}} {{result.result.vehicle.model}} {{result.result.vehicle.plate}}
                small D{{result.result.driver.id}} {{result.result.driver.name}} {{result.result.driver.surname}}
          SearchEntity(entity="vehicles",  @selected="gotoEntity($event, 'vehicles')").mb-1
            template(v-slot:default="result")
              .quick-search-result
                span V{{result.result.id}}
                small {{result.result.brand}} {{result.result.model}} {{result.result.plate}}
                small PL{{result.result.parking_lot.id}} {{result.result.parking_lot.name}}


</template>

<script>
import SearchEntity from "./SearchEntity.vue";
import {mapState} from "vuex";

export default {
  name: "QuickSearch",
  components: {SearchEntity},
  data() {
    return {
      searchOpen: false
    }
  },
  mounted() {

  },
  methods:{
    gotoEntity(id, entity) {
      switch (entity) {
        case 'clients':
          this.$router.push({name: 'client', params: {id}})
          break
        case 'drivers':
          this.$router.push({name: 'driver', params: {id}})
          break
        case 'reservations':
          this.$router.push({name: 'reservation', params: {id}})
          break
        case 'vehicles':
          this.$router.push({name: 'vehicle', params: {id}})
      }

      this.searchOpen = false
    },
    handleFocusout($evt){
      if ($evt.relatedTarget !== null) {
        return
      }
      this.searchOpen = false
    }
  },
  computed:{
    ...mapState({
      configuration: state => state.configuration,
    }),
  }
}
</script>
<style lang="sass">
.component-quick-search
  position: relative

  .search-container
    position: relative
    width: 100%
    &.clearfix
      clear: both
    .search
      position: absolute
      padding: 1em
      min-width: 300px
      right: 0
      margin-left: auto
      margin-right: auto
      z-index: 1
      &::after
        content: ""
        clear: both


    .quick-search-result
      display: flex
      flex-direction: column
</style>



// WEBPACK FOOTER //
// QuickSearch.vue?73fdf38b